// Shared UI helpers for severity, status, and HTTP method styling.

export const SEV = {
  critical: { label: "Critical", cls: "bg-[hsl(0_100%_68%/0.15)] text-[hsl(0_75%_55%)] border-[hsl(0_100%_68%/0.35)]" },
  high: { label: "High", cls: "bg-[hsl(24_95%_53%/0.15)] text-[hsl(24_90%_48%)] border-[hsl(24_95%_53%/0.35)]" },
  medium: { label: "Medium", cls: "bg-[hsl(38_92%_50%/0.15)] text-[hsl(38_85%_42%)] border-[hsl(38_92%_50%/0.35)]" },
  low: { label: "Low", cls: "bg-[hsl(217_91%_60%/0.12)] text-[hsl(217_85%_55%)] border-[hsl(217_91%_60%/0.3)]" },
  none: { label: "OK", cls: "bg-[hsl(160_84%_39%/0.12)] text-[hsl(160_70%_38%)] border-[hsl(160_84%_39%/0.3)]" },
};

export const methodColor = (m) => {
  switch ((m || "").toUpperCase()) {
    case "GET": return "text-[hsl(160_70%_40%)]";
    case "POST": return "text-[hsl(217_85%_58%)]";
    case "PUT": return "text-[hsl(38_85%_48%)]";
    case "PATCH": return "text-[hsl(280_65%_60%)]";
    case "DELETE": return "text-[hsl(0_75%_58%)]";
    default: return "text-muted-foreground";
  }
};

export const statusColor = (code) => {
  if (!code) return "text-[hsl(0_75%_58%)]";
  if (code < 300) return "text-[hsl(160_70%_40%)]";
  if (code < 400) return "text-[hsl(217_85%_58%)]";
  if (code < 500) return "text-[hsl(38_85%_48%)]";
  return "text-[hsl(0_75%_58%)]";
};

export const PHASES = {
  queued: { label: "Queued", pct: 0 },
  learning: { label: "Self-learning", pct: 15 },
  generating: { label: "Generating tests", pct: 35 },
  running: { label: "Executing tests", pct: 65 },
  analyzing: { label: "Analyzing", pct: 92 },
  completed: { label: "Completed", pct: 100 },
  failed: { label: "Failed", pct: 100 },
};
